angular.module('iconoglobe').directive('disableMainScroll',['$document', function($document){
  return {
    restrict: "AE",
    link: function(scope, element, attrs){
      var prevented;
      if(element.find('.slim-scroll-wrapper').length > 0){
        element.find('.slim-scroll-wrapper').bind('mousewheel DOMMouseScroll', function(e){
  
          var evt = window.event || e //equalize event object     
          evt = evt.originalEvent ? evt.originalEvent : evt; //convert to originalEvent if possible               
          var delta = evt.detail ? evt.detail*(-40) : evt.wheelDelta //check for detail first, because it is used by Opera and FF
          var scrolled = this.scrollTop + $(this).outerHeight();
  
  
          if(scrolled == this.scrollHeight && delta < 1){
            e.preventDefault();
          }         
        });
  
        var ts;
        element.find('.slim-scroll-wrapper').bind('touchstart', function(e) {
            ts = e.originalEvent.touches[0].clientY;
        });   
        
        element.find('.slim-scroll-wrapper').bind('touchmove', function(e){
          var scrolled = this.scrollTop + $(this).outerHeight();
          var te = e.originalEvent.changedTouches[0].clientY;
          if (ts > te && scrolled == this.scrollHeight) {
              //console.log('down');
              e.preventDefault();
          } else {
              //console.log('up');
          }       
        });
        
        element.find('.slim-scroll-wrapper').bind('touchend', function(e){
          
        });
      } else {
        //console.log('disable main scroll')
        element.bind('mousewheel DOMMouseScroll', function(e){
          //console.log("mousewheel DOMMouseScroll")
          var evt = window.event || e //equalize event object     
          evt = evt.originalEvent ? evt.originalEvent : evt; //convert to originalEvent if possible               
          var delta = evt.detail ? evt.detail*(-40) : evt.wheelDelta //check for detail first, because it is used by Opera and FF
          var scrolled = this.scrollTop + $(this).outerHeight();
          
          
          console.log(scrolled, this.scrollHeight ,delta);
          if(scrolled == this.scrollHeight && delta < 1){
            console.log("prevent mousewheel DOMMouseScroll")
            e.preventDefault();
          }         
        });
        var ts;
        element.bind('touchstart', function(e) {
            ts = e.originalEvent.touches[0].clientY;
            console.log('touch start');
        });   
        
        element.bind('touchmove', function(e){
          var scrolled = this.scrollTop + $(this).outerHeight();
          var te = e.originalEvent.changedTouches[0].clientY;
          if (ts > te && scrolled == this.scrollHeight) {
              //console.log('down');
              e.preventDefault();
          } else {
              //console.log('up');
          }       
        });
        
        element.bind('touchend', function(e){
          
        });
      }
    }
  }
}]);